import Link from "next/link";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, BlockText, Heading, Panel, Separator } from "@nju/ui";

interface IMySimCardBlockSuccess {
  userId: string | undefined;
}

export function MySimCardBlockSuccess({ userId }: IMySimCardBlockSuccess) {
  return (
    <Panel>
      <Heading
        align="center"
        font="ttfirs"
        tone="neutral"
        variant="h2"
        weight="bold"
      >
        gotowe!
      </Heading>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <Icon
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          name="sim-card-error-incircle"
        />
      </div>
      <Separator size="s" tone="invisible" />
      <BlockText
        align="center"
        size={{ "@onlyMobile": "s", "@fromTablet": "l" }}
      >
        Twoja karta zostanie wkrótce zablokowana.
        <Separator size="xxs" tone="invisible" />
        Może to chwilę potrwać.
      </BlockText>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center only-mobile:flex-col">
        <Link
          href={portalRoutes.mojeKonto.mojaKarta.index.get({
            ...(userId && { userId }),
          })}
          passHref={true}
        >
          <A size={{ "@onlyMobile": "s" }}>ok</A>
        </Link>
      </div>
    </Panel>
  );
}
